// Naming convention for flags: <app-name>.<page-name>.<flag-name> use hyphens for page-name and flag-name

export type CC9FlagNames =
  | "css.enable_dealer_code_service_use"
  | "cc9.test.testflag"
  | "cc9-client-search.show-download"
  | "cc9.account-copy.show"
  | "cc9.user-permissions-from-group-resource"
  | "cc9.get-legacy-data"
  | "cc9.resources-hide-ui"
  | "cc9.website-inventory-config.show-bulk-import"
  | "cc9.user-permissions-manager.enable"
  | "incentives-manager-access"
  | "cc9.media-library-copy.enable"
  | "css.franchise-management.enable"
  | "cis.account-creation.enable"
  | "alt-text-manager"
  | "welcome-page-access"
  | "inventory-manager-page-access"
  | "fee-manager-access"
  | "deptsvc.department-management.enable";

export type AutotraderFlagNames =
  | "autotrader.testflag"
  | "autotrader.new-merchandising-navbar-menu.enable";
export type TestFlagNames = "devTestFlag";
export type GenericFlags<TFlagNames extends string> = Partial<
  Record<TFlagNames, boolean>
>;

export type AllFlagsNames = TestFlagNames | CC9FlagNames | AutotraderFlagNames;

type AppNames = "test" | "cc9" | "autotrader";

type Flags = { name: AllFlagsNames; apps: AppNames[]; description: string }[];

const FLAGS: Flags = [
  {
    name: "cc9.website-inventory-config.show-bulk-import",
    apps: ["cc9"],
    description:
      "Enables the bulk import button on the website inventory config page"
  },
  {
    name: "css.enable_dealer_code_service_use",
    apps: ["cc9"],
    description:
      "Was used to enable new api for dealer codes. This needs to be removed"
  },
  {
    name: "cc9-client-search.show-download",
    apps: ["cc9"],
    description: "Shows download button in account search"
  },
  /** Mock flag only for test page */
  {
    name: "devTestFlag",
    apps: ["test"],
    description: "Test flag for testing purposes"
  },
  {
    name: "cc9.test.testflag",
    apps: ["cc9"],
    description:
      "Test flag for testing purposes. Feels like we shouldn't need two of these"
  },
  {
    name: "cc9.account-copy.show",
    apps: ["cc9"],
    description: "Adds media library copy link to navigation"
  },
  {
    name: "cc9.user-permissions-from-group-resource",
    apps: ["cc9"],
    description:
      "Gets userPermissionsFromGroupResource property on the resources get fetch call"
  },
  {
    name: "cc9.resources-hide-ui",
    apps: ["cc9"],
    description: "Hides the 'Inherit from parent' menu button on resouces page"
  },
  {
    name: "cc9.get-legacy-data",
    apps: ["cc9"],
    description: "Gets legacy data from the resources get fetch call"
  },
  {
    name: "autotrader.testflag",
    apps: ["autotrader"],
    description: "Test flag for testing purposes"
  },
  {
    name: "autotrader.new-merchandising-navbar-menu.enable",
    apps: ["autotrader"],
    description:
      "Enable renders new DealerCenter navbar with DealerCenter URLs for merchandising pages"
  },
  {
    name: "cc9.user-permissions-manager.enable",
    apps: ["cc9"],
    description: "Show user permissions manager page"
  },
  {
    name: "incentives-manager-access",
    apps: ["cc9"],
    description: "Enables access to the incentives manager page"
  },
  {
    name: "cc9.media-library-copy.enable",
    apps: ["cc9"],
    description: "Use CC9 Media Library Copy endpoint"
  },
  {
    name: "css.franchise-management.enable",
    apps: ["cc9"],
    description: "Enables Franchise Management features"
  },
  {
    name: "cis.account-creation.enable",
    apps: ["cc9"],
    description: "Enables Account Creation features"
  },
  {
    name: "alt-text-manager",
    apps: ["cc9"],
    description: "Enables the Alt Text Manager tab"
  },
  {
    name: "deptsvc.department-management.enable",
    apps: ["cc9"],
    description:
      "Enables the new department service endpoints for CRUD operations and database. Controls add, edit, and delete buttons for DDC dealer departments"
  },
  {
    name: "welcome-page-access",
    apps: ["cc9"],
    description: "Controls access to the welcome page"
  },
  {
    name: "inventory-manager-page-access",
    apps: ["cc9"],
    description: "Controls access to the inventory manager page"
  },
  {
    name: "fee-manager-access",
    apps: ["cc9"],
    description: "Controls access to the fee manager page"
  }
];

export const getActiveFlags = (appName: AppNames) => {
  return FLAGS.reduce((acc, { name, apps }) => {
    if (apps.some(app => app === appName)) {
      return {
        ...acc,
        [name]: true
      };
    } else {
      return acc;
    }
  }, {});
};
